module.exports = "/_next/static/images/d2d0ebf8781d22f6fc720628f24c142b-value-props.png.webp";